export default class Usuario{

    constructor(model = null){

        this.id = 0;
        this.empresaId = 0;
        this.empresa = null;
        this.nome = '';
        this.senha = '';
        this.email = '';
        this.pessoalId = null;
        this.temaEscuro = 0;
        this.foto = null;
        this.permissoes = [];
        
        if(!model)
            return;

        this.id = model.id ? model.id : 0;
        this.empresaId = model.empresaId;
        this.empresa = model.empresa;
        this.nome = model.nome;
        this.senha = model.senha;
        this.email = model.email;
        this.pessoalId = model.pessoalId;
        this.temaEscuro = model.temaEscuro;
        this.foto = model.foto;
        this.permissoes = model.permissoes;        
    }

}